import type { ColumnDef, ColumnType, DemoKey } from '../types';

export function isNumeric(type: ColumnType): boolean {
  return type === 'quantitative-discrete' || type === 'quantitative-continuous';
}

export function isOrdered(type: ColumnType): boolean {
  return isNumeric(type) || type === 'qualitative-ordinal';
}

export function valueOrder<Row>(col: ColumnDef<Row>, value: string): number {
  if (col.type !== 'qualitative-ordinal' || !col.ordinalOrder) return Number.NaN;
  return col.ordinalOrder.indexOf(value);
}

/**
 * The i18n key for a tag's label, e.g. `tag.football.label`. Tag values are
 * runtime data (a column's `tags` array), not a literal type, so TypeScript
 * can't narrow the template result to `DemoKey` on its own — this is the one
 * audited cast in the statistics i18n guardrail sweep.
 */
export const tagKey = (tag: string): DemoKey => `tag.${tag}.label` as DemoKey;

/**
 * The i18n key for a column type's chip text, e.g. `type.qualitative-nominal.label`
 * or `type.qualitative-nominal.def`. `ColumnType` is a widened union at the call
 * site (read off a `ColumnDef`), so TypeScript can't narrow the template result
 * to `DemoKey` on its own — audited: every `ColumnType` member has both a
 * `.label` and a `.def` entry in the `DemoKey` union (see types.ts).
 */
export const typeKey = (type: ColumnType, variant: 'label' | 'def'): DemoKey =>
  `type.${type}.${variant}` as DemoKey;
